module.exports = __webpack_public_path__ + "static/img/web_7_activities low size.8d6cb46f.jpg";